import { render, staticRenderFns } from "./FilterBoostedDapp.vue?vue&type=template&id=a383588c&scoped=true"
import script from "./FilterBoostedDapp.vue?vue&type=script&lang=ts"
export * from "./FilterBoostedDapp.vue?vue&type=script&lang=ts"
import style0 from "./FilterBoostedDapp.vue?vue&type=style&index=0&id=a383588c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a383588c",
  null
  
)

export default component.exports